import MyTable from "../../Component/MyTable"
import { MenuItem, ListItemIcon, ListItemText, Alert, Paper,  Typography,  Stack, Snackbar, Backdrop, ButtonGroup, FormControl, InputLabel, Select,   IconButton, Tooltip, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { apiResult, getUserSession, } from "../../Utils/Common";
import apis from "../../api";
import { RightDrawer } from "../../Component/MuiEx";
import {  useParams } from "react-router";
import DownMenuItem from "../../Component/DownMenuItem"
import { getItemsFromObjects, loadCourseCategories,  } from "../../Component/DataLoader";
import { CourseLoader } from "../fragement/CourseSelector";
import CourseRecharge from "./fragement/CourseRecharge";
import {   ArrowForwardOutlined, PlaylistAddOutlined, VisibilityOutlined } from "@mui/icons-material";
import { MemberAutoComplete } from "../fragement/MemberAutoComplete";
import { CoursePackageSelect } from "../fragement/CoursePackageSelector";
import { MemberItem } from "./fragement/MemberItems";
import CourseOrder from "./fragement/CourseOrder";
import MyTabs from "../../Component/MyTabs";
import MemberCourseRecords from "./fragement/MemberCourseRecords";

const MemberCourses = () => {
    const [loading, setLoading] = useState(false)
    const [rightDrawer, setRightDrawer] = useState()
    const [hintMsg, setHintMsg] = useState()
    const [datas, setDatas] = useState([])
    const [categories, setCategories] = useState()
    const [courses, setCourses] = useState()
    const [error, setError] = useState()
    const [page, setPage] = useState(0)
    const [totalRecords, setTotalRecords] = useState(0)
    const [currentRow,setCurrentRow] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    getUserSession(apis)
    const params = useParams()
    const [member_id, setMemberID] = useState(params.member_id > 0 ? params.member_id : 0)    
    const [category_id,setCategoryID] = useState(params.category_id>0?params.category_id:0)
    const [course_package_id, setCoursePackageID] = useState(0)
    const handleHintClose = () => {
        setHintMsg()
    }
    const loadDatas = (page) => {
        setLoading(true)
        apis.membercourseGet(category_id,course_package_id,member_id,page).then(ret => {
            apiResult(ret, (r) => {
                if (page == 0) {
                    setTotalRecords(r.total)
                    setDatas(r.data)
                } else {
                    setDatas(r)
                }
            }, setError)
            setLoading()
        })
    }
    let initPage = false
    useEffect(() => {
        if (initPage) return
        initPage = true
        loadCourseCategories(apis, (data) => setCategories(data), setError)        
        // loadCoursePackages(0,1,apis,setPackages,setError)
        CourseLoader((data) => setCourses(data), apis, false, setError)
    }, [])
    useEffect(() => {
        loadDatas(page)
    }, [category_id,member_id, course_package_id,page])

    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }
    const handleAdd = () => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<CourseRecharge onRecharged={() => { setRightDrawer(false); loadDatas(0) }} member={member_id} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleView = (idx, item) => {
        if(currentRow == item) {
            setCurrentRow()
        }else {
            setCurrentRow(item)
        }
    }

    const TableHeader = [
        { name: 'id', showName: 'ID' },
        {
            name: 'member_id', showName: 'Member', func: (v, idx, item) => {
                let category = item.course_package?.category_id > 0 && getItemsFromObjects(categories, item.course_package.category_id)
                let course = item.course_package?.course_id > 0 && getItemsFromObjects(courses, item.course_package.course_id)                
                return <Box>
                    <MemberItem member={item.member} onError={setError} />
                    <Typography sx={{color:"gray",fontSize:"12px"}}>{category?.name + "/" + (course ? course.name : "*") + (item.course_package?.billtype==0 && ("(" + item.course_package?.minutes + "m / lesson)"))}</Typography>
                </Box>
            }
        },    
        
        {
            name: 'remained', showName: 'Remained', func: (v, idx, item) => {
                let t = item.course_package?.billtype == 1?((v / 60).toFixed(1) + " hours"):(v + " lessons")
                let tt = item.course_package?.billtype == 1?((item.total / 60).toFixed(1) + " hours"):(item.total + " lessons")                
                let vv = (item.course_package?.billtype == 1?v/60:v)
                return <Box>
                    <Typography sx={{color:vv==0?"red":(vv<3?"orange":"#")}}>{t}</Typography>
                    <Typography sx={{color:"gray",fontSize:"12px"}}>Total: {tt}</Typography>
                </Box>
            }
        },        
        {
            name: 'option', showName: 'Orders', func: (v, idx, item) => {
                return <ButtonGroup size="small" variant="contained" aria-label="outlined primary button group">
                    {/* <Button variant={item.status == 0 ? "outlined" : "contained"} onClick={() => item.status != 0 ? handleDelete(idx, item) : handleEnable(idx, item)}>{item.status == 0 ? 'Disable' : 'Enable'}</Button> */}
                    <Tooltip title="View orders"><IconButton onClick={() => handleView(idx, item)}>{currentRow == item?<ArrowForwardOutlined />:<VisibilityOutlined />}</IconButton></Tooltip>
                </ButtonGroup>
            }
        },
    ]
    const OptionButton = [
        { text: "Recharge Course", icon: <PlaylistAddOutlined fontSize="small" />, onClick: handleAdd },
    ]
    return (
        <>
            <Backdrop open={loading} />
            {error && <Alert severity={"warning"} sx={{ width: '100%', marginTop: "5px", mb: 2 }} onClose={() => setError()}>{error}</Alert>}
            <Paper sx={{ marginBottom: 2,p:1, display: 'flex' }}>
                <FormControl sx={{ width: 400, mr: 1 }}>
                    <InputLabel id="select-category">{"Select Category"}</InputLabel>
                    {categories && <Select labelId="select-category"
                        defaultValue={category_id}
                        id="categoryid" onChange={(e) => { setPage(0);setCategoryID(e.target.value);  }}
                        label={"Select Category"}>
                        {categories && [{ id: 0, name: "All" },...categories, ].map((p, idx) => {
                            return <MenuItem key={idx} value={p.id}>{p.name}</MenuItem>
                        })}
                    </Select>}
                </FormControl>                
                <CoursePackageSelect sx={{width:800,mr:1}} categoryid={category_id} name={"coursepackage"} lable={"Course Package"} onChange={(n,v)=>{setPage(0);setCoursePackageID(v?v.id:0);}} />
                <MemberAutoComplete sx={{ width:500 }} defaultValue={member_id} name="member_id" onChange={(name, value) => { setPage(0);setMemberID(value?.id); }} />                
                <Typography sx={{ flex: '1 1 30%' }} variant="h6" component="div" ></Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }}>
                    {OptionButton.map((item, index) => {
                        return item.subItems ? <DownMenuItem key={index} icon={item.icon} onClick={item.onClick} items={item.subItems} text={item.text} /> :
                            <MenuItem key={index} onClick={item.onClick}>
                                {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}<ListItemText>{item.text}</ListItemText>
                            </MenuItem>
                    })}
                </Stack>
            </Paper>
            {datas.length == 0 && <Alert severity={"info"}>Ops! There is not any data</Alert>}
            <Stack direction={"row"}>
                {datas.length > 0 && <MyTable
                    height={650}
                    rows={datas}
                    totalRow={totalRecords}
                    headers={TableHeader}
                    singleOption={true}
                    checkbox={false}
                    rowsPerPage={10}    
                    onChangePage={(p,pr)=>{setPage(p);setCurrentRow()}}            
                />}
                {currentRow && 
                    <MyTabs sx={{minWidth:"50%",ml:2}} labels={["Course orders","Course lesson records"]} items={[
                        <CourseOrder  sx={{minWidth:"100%"}} memberid={currentRow.member_id} coursepackageid={currentRow.course_package_id} onRefunded={()=>{loadDatas(page)}} />,
                        <MemberCourseRecords sx={{minWidth:"100%",maxHeight:"75vh",overflow:"auto"}} memberCourse={currentRow} onMemberCourseUpdate={()=>{loadDatas(page)}}/>
                    ]}/>
                }
            </Stack>
            {hintMsg && <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={hintMsg ? true : false} autoHideDuration={3000} onClose={handleHintClose}>
                <Alert onClose={handleHintClose} severity="success" sx={{ width: '100%' }}>{hintMsg}</Alert>
            </Snackbar>}
            <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
                {rightDrawer}
            </RightDrawer>
        </>

    )
}
export default MemberCourses